import { axios } from '@Root/API'

export const deleteStudentCourseSession = id => {
	return axios.delete(`engagement/${id}/student-registration`)
}
